var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5006 4.5V6.13L4.23058 8.9C3.88058 8.96 3.57058 9.15 3.34058 9.42C3.11058 9.69 2.99058 10.04 3.00058 10.4V13.65C3.00058 14.01 3.11058 14.35 3.34058 14.63C3.57058 14.9 3.88058 15.09 4.23058 15.15L6.00058 15.41V17.99C6.00058 18.39 6.16058 18.77 6.44058 19.05C6.72058 19.33 7.10058 19.49 7.50058 19.49H13.5006C13.9006 19.49 14.2806 19.33 14.5606 19.05C14.8406 18.77 15.0006 18.39 15.0006 17.99V17.04L19.5006 17.86V19.49H21.0006V4.5H19.5006ZM13.5006 18H7.50058V15.7L13.5006 16.79V18.01V18ZM4.50058 13.63V10.37L19.5006 7.65V16.35L4.50058 13.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSpeaker);
export default __webpack_public_path__ + "static/media/ic-speaker.b94ce434e785f8172a72251b988a7145.svg";
export { ForwardRef as ReactComponent };